import { Component } from 'components/account-settings';

/** @ngInject */
export default function accountSettingsRouter($stateProvider) {
    const baseState = {
        url: '/account-settings',
        views: {
            content: {
                component: Component.selector
            }
        }
    };

    $stateProvider
        .state('main.account-settings', baseState);
}



// WEBPACK FOOTER //
// ./app/components/account-settings/account-settings.router.js